<template>
    <v-form ref="form" @submit.prevent="save">
        <v-card>
            <card-header :title="title" />
            <v-card-text>
                <v-row>
                    <v-col>
                        <v-text-field
                            :label="
                                $t('resources.popupSetting.attributes.title')
                            "
                            v-model="popup.title"
                        />
                    </v-col>

                    <v-col>
                        <v-text-field
                            :label="
                                $t(
                                    'resources.popupSetting.attributes.redirect_to',
                                )
                            "
                            v-model="popup.redirect_to"
                        />
                    </v-col>

                    <v-col>
                        <v-text-field
                            :label="
                                $t('resources.popupSetting.attributes.width')
                            "
                            v-model="popup.width"
                            :hint="$t('resources.popupSetting.hints.width')"
                        />
                    </v-col>
                </v-row>

                <v-textarea
                    :label="$t('resources.popupSetting.attributes.content')"
                    v-model="popup.content"
                    :hint="$t('resources.popupSetting.hints.content')"
                />

                <v-row>
                    <v-col class="d-flex flex-row">
                        <v-switch
                            :label="
                                $t(
                                    'resources.popupSetting.attributes.persistent',
                                )
                            "
                            v-model="popup.persistent"
                            class="mr-6"
                            persistent-hint
                            :hint="
                                $t('resources.popupSetting.hints.persistent')
                            "
                        />

                        <v-switch
                            :label="
                                $t(
                                    'resources.popupSetting.attributes.touchable',
                                )
                            "
                            v-model="popup.touchable"
                            class="mr-6"
                            persistent-hint
                            :hint="$t('resources.popupSetting.hints.touchable')"
                        />
                    </v-col>
                </v-row>
            </v-card-text>
            <FormActions :loadingSave="saving">
                <template #left>
                    <v-btn color="primary" @click="preview()">
                        Preview
                    </v-btn>
                </template>
            </FormActions>
        </v-card>

        <PopupPreview :popup="popup" :previewMode="true" ref="preview" />
    </v-form>
</template>

<script>
import FormActions from '@/shared/components/FormActions'
import Popup from '@/models/settings/Popup'
import PopupPreview from '@/shared/components/Popup'
import i18n from '@/plugins/i18n'

export default {
    props: {
        model: {
            type: Object,
            required: true,
            validator: model => {
                return model instanceof Popup
            },
        },
        titlePrefix: String,
    },

    components: {
        FormActions,
        PopupPreview,
    },

    data: () => {
        return {
            saving: false,
            popup: this.model,
        }
    },

    computed: {
        title() {
            return i18n.t('forms.title', {
                prefix: this.titlePrefix,
                resource: i18n.tc('resources.popupSetting.name', 1),
            })
        },
    },

    methods: {
        async preview() {
            await this.$refs.preview.forceRerender()
            this.$refs.preview.open()
        },

        async save() {
            this.saving = true
            let res = await this.popup.save()
            this.saving = false

            if (!res) return

            this.$bus.$emit(
                'notify',
                'success',
                i18n.t('forms.messages.saved', {
                    resource: i18n.tc('resources.popupSetting.name', 1),
                }),
            )
            this.$emit('saved')
        },
    },
}
</script>

<style></style>
